import { memo } from "react";
import { View } from "react-native";
import { Slider } from "../../../common/shadcn/slider";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import StyledText from "../../../common/ui/styled-text";
import { Volume1, Volume2 } from "lucide-react-native";

const AmbientNoiseVolumeSetting = () => {
  const { settings, handleAmbientNoiseVolume, isTestCallActive } =
    useSettingsData();

  return (
    <View className="flex justify-center items-center w-full">
      <View className="flex-row items-center justify-center w-full max-w-md">
        <Slider
          className="flex-1 w-[180px] sm:w-[370px]"
          value={[settings.ambientNoiseVolume]}
          onValueChange={([value]) => handleAmbientNoiseVolume(value)}
          min={1}
          max={100}
          trackColor="#f3f4f6"
          thumbColor="#1f2937"
          disabled={isTestCallActive}
        />
        <View className="flex-row items-center w-24 flex-shrink-0">
          <StyledText className="text-sm text-gray-500 justify-end pl-2 w-12 text-right select-none">
            {settings.ambientNoiseVolume}%
          </StyledText>
          <View className="flex-shrink-0 w-6 ml-2">
            {settings.ambientNoiseVolume < 51 ? (
              <Volume1 size={16} color="#6b7280" />
            ) : (
              <Volume2 size={16} color="#6b7280" />
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default memo(AmbientNoiseVolumeSetting);
